import React from "react";
import { BrowserRouter, Routes as RouterRoutes, Route } from "react-router-dom";
import ScrollToTop from "components/ScrollToTop";
import ErrorBoundary from "components/ErrorBoundary";
import NotFound from "pages/NotFound";
import AIIntelligenceReports from './pages/ai-intelligence-reports';
import AccountManagement from './pages/account-management';
import DashboardOverview from './pages/dashboard-overview';
import SalesOrderingSystem from './pages/sales-ordering-system';
import PhilippineMapVisualization from './pages/philippine-map-visualization';
import PerformanceAnalytics from './pages/performance-analytics';

const Routes = () => {
  return (
    <BrowserRouter>
      <ErrorBoundary>
      <ScrollToTop />
      <RouterRoutes>
        {/* Define your route here */}
        <Route path="/" element={<AccountManagement />} />
        <Route path="/ai-intelligence-reports" element={<AIIntelligenceReports />} />
        <Route path="/account-management" element={<AccountManagement />} />
        <Route path="/dashboard-overview" element={<DashboardOverview />} />
        <Route path="/sales-ordering-system" element={<SalesOrderingSystem />} />
        <Route path="/philippine-map-visualization" element={<PhilippineMapVisualization />} />
        <Route path="/performance-analytics" element={<PerformanceAnalytics />} />
        <Route path="*" element={<NotFound />} />
      </RouterRoutes>
      </ErrorBoundary>
    </BrowserRouter>
  );
};

export default Routes;
